var map = {
	"./car-features/ev.svg": "95UI",
	"./car-features/has_air_condition.svg": "dQpW",
	"./car-features/has_navigation_system.svg": "p9Wr",
	"./car-features/has_range_extender.svg": "m8We",
	"./car-features/has_seat_for_child.svg": "BPF2",
	"./car-features/number_of_bags.svg": "MiAi",
	"./car-features/number_of_doors.svg": "XIOy",
	"./car-features/number_of_seats.svg": "qyzC",
	"./car-features/payload.svg": "qAcX",
	"./car-features/tire_type.svg": "3z0J",
	"./car-features/transmission.svg": "0Jpj",
	"./enabled_by_moqo.svg": "xBiB",
	"./enabled_by_moqo_home.svg": "N0Xg",
	"./enabled_by_moqo_work.svg": "koos",
	"./icon_bike.svg": "iYcg",
	"./icon_document.svg": "+fjX",
	"./icon_electro.svg": "XPev",
	"./icon_gas_station.svg": "u0la",
	"./icon_location.svg": "JX8C",
	"./icon_new_user.svg": "8YOs",
	"./icon_open.svg": "4xNB",
	"./icon_pricing.svg": "XqUl",
	"./icon_shield.svg": "j3sZ",
	"./icon_smartphone.svg": "9Tfq",
	"./icon_star.svg": "TElv",
	"./icon_thumb_up.svg": "x6CU",
	"./icon_time.svg": "W+kw",
	"./icon_vehicle.svg": "xzES"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UFRR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = UFRR
// module chunks = 1